import { ExButton } from '@commons/EXComponentsLibrary';
import { MessagesDragDropUploader } from '@commons/components/OpenSearchBanner/DragDropUploader';
import styles from './DropzoneFormatStatusV2.module.css';

import Image from 'next/image';
import { t } from 'i18next';
import { useUser } from 'utils/hooks';
import { IProps } from './DropzoneFormatStatusV2.interface';
import { LoaderDragDropFile } from '@commons/components/NewDragDropUploader';

const DropzoneFormatStatusV2 = ({
    isDisabled,
    progress,
    fileName,
    isLoading,
    isComplete,
    isInvalidExtensionFile,
    showUploadedFileName,
    errorMissingFile
}: IProps) => {
    const { user } = useUser({});
    const EX5990 = user?.EX5990;
    const isInitialState = !isLoading && !isComplete;

    return (
        <>
            <div
                className={
                    isDisabled
                        ? styles['container-dropzone-disabled']
                        : isInvalidExtensionFile
                        ? styles['container-dropzone-error']
                        : errorMissingFile
                        ? styles['container-dropzone-error-missing-file']
                        : styles['container-dropzone']
                }
            >
                {isInvalidExtensionFile && (
                    <MessagesDragDropUploader
                        text={'Solo podés subir archivos de texto'}
                        subtitle={'Asegurate que el formato de archivo que estas intentando subir sea el correcto.'}
                        src="/assets/images/cancel.svg"
                        blockerFormat={true}
                        flag={false}
                    />
                )}
                {isDisabled && (
                    <>
                        <Image
                            src="/assets/images/upload_cloud_blue_disabled.svg"
                            alt="upload-icon-disabled"
                            width={40}
                            height={40}
                        />
                        <div className={styles['text-dropzone-container-disabled']}>
                            <span className={styles['text-dropzone']}>
                                Arrastrá y soltá el archivo que usas para pedir a la droguería.
                            </span>
                            <span className={styles['text-dropzone']}>
                                {EX5990
                                    ? t('credentialplaceholder_twentyTwo')
                                    : 'Todos los archivos de texto son válidos'}
                            </span>
                        </div>
                        <ExButton appearance="outline" size="sm" disabled={isDisabled}>
                            {EX5990 ? t('credentialplaceholder_sixteen') : 'Subir archivo'}
                        </ExButton>
                    </>
                )}
                {isInitialState && !isInvalidExtensionFile && !isDisabled && (
                    <>
                        <Image src="/assets/images/upload_cloud_blue.svg" alt="upload-icon" width={40} height={40} />
                        <div className={styles['text-dropzone-container']}>
                            <span className={styles['text-dropzone']}>
                                Arrastrá y soltá el archivo que usas para pedir a la droguería.
                            </span>
                            <span className={styles['text-dropzone']}>
                                {EX5990
                                    ? t('credentialplaceholder_twentyTwo')
                                    : 'Todos los archivos de texto son válidos'}
                            </span>
                        </div>
                        <ExButton appearance="outline" size="sm" disabled={isDisabled}>
                            {EX5990 ? t('credentialplaceholder_sixteen') : 'Subir archivo'}
                        </ExButton>
                    </>
                )}
                {isLoading && <LoaderDragDropFile />}
                {isLoading && (
                    <div className={styles['text-uploading-file']}>
                        {t('offlineDrugManufacturer.placeholder.uploadingList', { listName: fileName?.label })}
                    </div>
                )}
                {isComplete && (
                    <div className={styles['text-uploaded-file']}>
                        {t('offlineDrugManufacturer.placeholder.uploadSuccessful', { listName: fileName?.label })}
                    </div>
                )}
                {(isLoading || isComplete) && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                        <div
                            style={{
                                width: '100% !important',
                                height: '4px',
                                borderRadius: '24px',
                                backgroundColor: '#E3ECFF',
                                border: '0.5px solid #BED0E5',
                            }}
                        >
                            <div
                                style={{
                                    width: `${progress}%`,
                                    backgroundColor: '#07AD4B',
                                    height: '100%',
                                    transition: 'all .3s',
                                }}
                            ></div>
                        </div>
                        <div className={styles['text-number-progress']}>{progress} %</div>
                    </div>
                )}
            </div>
            {showUploadedFileName && (
                <div className={styles['container-file-uploaded']}>
                    <div className={styles['container-file-uploaded-text-with-img']}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.0003 10.5002C12.0003 11.6557 11.5948 12.6391 10.7837 13.4502C9.97255 14.2613 8.98921 14.6668 7.83366 14.6668C6.6781 14.6668 5.69477 14.2613 4.88366 13.4502C4.07255 12.6391 3.66699 11.6557 3.66699 10.5002V4.3335C3.66699 3.50016 3.95866 2.79183 4.54199 2.2085C5.12533 1.62516 5.83366 1.3335 6.66699 1.3335C7.50033 1.3335 8.20866 1.62516 8.79199 2.2085C9.37533 2.79183 9.66699 3.50016 9.66699 4.3335V10.1668C9.66699 10.6779 9.48921 11.1113 9.13366 11.4668C8.7781 11.8224 8.34477 12.0002 7.83366 12.0002C7.32255 12.0002 6.88921 11.8224 6.53366 11.4668C6.1781 11.1113 6.00033 10.6779 6.00033 10.1668V4.66683C6.00033 4.47794 6.06421 4.31961 6.19199 4.19183C6.31977 4.06405 6.4781 4.00016 6.66699 4.00016C6.85588 4.00016 7.01421 4.06405 7.14199 4.19183C7.26977 4.31961 7.33366 4.47794 7.33366 4.66683V10.1668C7.33366 10.3113 7.38088 10.4307 7.47533 10.5252C7.56977 10.6196 7.68921 10.6668 7.83366 10.6668C7.9781 10.6668 8.09755 10.6196 8.19199 10.5252C8.28644 10.4307 8.33366 10.3113 8.33366 10.1668V4.3335C8.32255 3.86683 8.15866 3.47239 7.84199 3.15016C7.52533 2.82794 7.13366 2.66683 6.66699 2.66683C6.20033 2.66683 5.80588 2.82794 5.48366 3.15016C5.16144 3.47239 5.00033 3.86683 5.00033 4.3335V10.5002C4.98921 11.2891 5.26144 11.9585 5.81699 12.5085C6.37255 13.0585 7.04477 13.3335 7.83366 13.3335C8.61144 13.3335 9.27255 13.0585 9.81699 12.5085C10.3614 11.9585 10.6448 11.2891 10.667 10.5002V4.66683C10.667 4.47794 10.7309 4.31961 10.8587 4.19183C10.9864 4.06405 11.1448 4.00016 11.3337 4.00016C11.5225 4.00016 11.6809 4.06405 11.8087 4.19183C11.9364 4.31961 12.0003 4.47794 12.0003 4.66683V10.5002Z"
                                fill="#40435B"
                            />
                        </svg>
                        {fileName?.label}
                    </div>
                    <div className={styles['container-file-uploaded-text-size']}>{fileName.size} KB</div>
                </div>
            )}
        </>
    );
};

export default DropzoneFormatStatusV2;
